import { useStoreState } from "pullstate";
import ProxyAccountStore from "./proxyAccountStore";

/**
 * True while the signed-in person is acting on behalf of another account.
 *
 * Components should use this rather than isProxying(), which reads the store
 * once without subscribing and so would not re-render when a session starts
 * or ends.
 */
export var useIsProxying = function useIsProxying() {
  var targetAccountId = useStoreState(ProxyAccountStore, function (store) {
    return store.targetAccountId;
  });
  return targetAccountId !== null;
};
export default useIsProxying;